import { SaveButton } from "components/Buttons"
import React, { forwardRef } from "react"
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  ListGroupItem,
  Row,
  UncontrolledDropdown,
} from "reactstrap"

const CalendarItem = forwardRef(
  (
    {
      reorderSubcalendarsHandler,
      toggleHandler,
      addSubCalendarHandler,
      calendarActions,
      style,
      attributes,
      listeners,
      ...props
    },
    ref
  ) => {
    return (
      <div ref={ref} style={style}>
        <ListGroupItem
          className="mt-3"
          style={{ background: "#F0F0F0" }}
          onClick={toggleHandler}
          id={"toggler" + props?.calendar?.id?.toString()}
        >
          <Row>
            <Col
              xs="auto"
              className="mt-1 align-self-center"
              {...attributes}
              {...listeners}
            >
              <i
                className="bx bx-menu font-size-20"
                style={{ cursor: "pointer" }}
                onClick={e => {
                  e.stopPropagation()
                }}
              />
            </Col>
            <Col xs="auto" className="align-self-center">
              <div
                style={{
                  height: "18px",
                  width: "18px",
                  backgroundColor: props?.calendar?.color,
                }}
              />
            </Col>
            <Col className="mt-1 align-self-center">
              <h5 className="font-size-18">{props?.calendar?.name}</h5>
            </Col>
            <Col xs="auto" className="align-self-center">
              <i
                className="bx bx-sort-a-z font-size-22"
                style={{ cursor: "pointer" }}
                onClick={e => {
                  e.stopPropagation()
                  reorderSubcalendarsHandler()
                }}
              />
            </Col>
            <Col xs="auto">
              <SaveButton
                size="sm"
                content="Add Sub Calendar"
                onClick={addSubCalendarHandler}
              />
            </Col>
            <Col xs="auto">
              <UncontrolledDropdown onClick={e => e.stopPropagation()}>
                <DropdownToggle href="#" className="card-drop" tag="i">
                  <i
                    className="mdi mdi-dots-vertical font-size-18"
                    style={{ cursor: "pointer" }}
                  />
                </DropdownToggle>
                {!!calendarActions && (
                  <DropdownMenu className="dropdown-menu-end">
                    {calendarActions.map((a, index) => (
                      <DropdownItem
                        key={index}
                        href="#"
                        onClick={e => {
                          e.preventDefault()
                          a.onClick(props?.calendar)
                        }}
                      >
                        <i className={a.icon} /> {a.name}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                )}
              </UncontrolledDropdown>
            </Col>
          </Row>
        </ListGroupItem>
      </div>
    )
  }
)

export default CalendarItem
